import { object } from '@calendly/form/validation'
import { useSelector } from 'react-redux'

import { getPaymentsValidationSchema, BILLING_FEATURE_KEY, preparePaymentsValuesForPreview } from 'components/event_type_edit'
import { isRestrictedFeatureSelector } from 'features/billing'

import { resolvePaymentProviderForServer } from './payment_provider_utils'

export const getInitialValues = (eventType) => {
  const paymentMethod = eventType.payment_method || {}
  const amountCents = Number(paymentMethod.amount_cents || 0)
  const rawProvider = (paymentMethod.enabled && paymentMethod.provider) || 'none'

  return {
    paymentId: paymentMethod.id,
    provider: rawProvider,
    currency: paymentMethod.currency || 'USD',
    amount: amountCents / 100,
    paymentTerms: paymentMethod.payment_terms || ''
  }
}

export const usePrepareValuesForPreview = () => {
  const isUpgradeRequired = useSelector((state) => isRestrictedFeatureSelector(state, { featureKey: BILLING_FEATURE_KEY }))

  return (eventType, formValues) => (
    preparePaymentsValuesForPreview(eventType, formValues, isUpgradeRequired)
  )
}

export const getFormatValuesToServerData = (eventType) => (values) => {
  const { paymentId, provider, amount, currency, paymentTerms } = values

  const serverProvider = resolvePaymentProviderForServer(provider, eventType)

  return {
    payment_method_attributes: {
      id: paymentId,
      provider: serverProvider,
      amount: provider === 'none' && !amount ? null : amount,
      currency,
      payment_terms: paymentTerms,
      enabled: provider !== 'none',
    }
  }
}

export const getValidationSchema = ({ useCrudValidationMessages = false } = {}) => object({})
  .concat(getPaymentsValidationSchema({ useCrudValidationMessages }))
